export default __webpack_public_path__ + "static/media/setpoint-landing.127ea0e2.png";